import { useState } from 'react';
import axios from 'axios';
import { syncCentralSettingsCache } from '../utils/centralSettingsCache.js';

const usePut = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const putData = async (url, payload) => {
        setLoading(true);
        setError(null);
        const token = localStorage.getItem('token');
        try {
            const response = await axios.put(url, payload,{
                headers:{
                    'Authorization': `Bearer ${token}` 
                }
            });

            const isCentralSettingsRequest = url?.includes('/settings/central')
                && payload?.scope === 'global'
                && payload?.tenantId
                && payload?.companyId;

            if (isCentralSettingsRequest) {
                syncCentralSettingsCache({
                    tenantId: payload.tenantId,
                    companyId: payload.companyId,
                    scope: payload.scope,
                    data: response?.data?.data || payload?.data || null,
                    version: response?.data?.version
                });
            }

            setData(response.data);
            console.log('Post Request:',`URL:` ,url, `PAYLOAD:`,payload,`RESPONE:`,response.data);
            return response.data;
        } catch (error) {
            console.log(error)
            setError(error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    return { data, loading, error, putData };
};

export default usePut;
